export default __webpack_public_path__ + "static/media/win.8498b53b.png";